import util from '@bmp-vue/core/api/util'
const controller = 'Stefanini'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get () {
    return [
      { modelo: 0, prazoInicio: 1, prazoFim: 23, taxa: 1.95 },
      { modelo: 0, prazoInicio: 24, prazoFim: 35, taxa: 1.85 },
      { modelo: 0, prazoInicio: 36, prazoFim: 47, taxa: 1.75 },
      { modelo: 0, prazoInicio: 48, prazoFim: 60, taxa: 1.75 },
      { modelo: 1, prazoInicio: 1, prazoFim: 23, taxa: 2.36 },
      { modelo: 1, prazoInicio: 24, prazoFim: 35, taxa: 1.95 },
      { modelo: 1, prazoInicio: 36, prazoFim: 47, taxa: 1.82 },
      { modelo: 1, prazoInicio: 48, prazoFim: 60, taxa: 1.80 },
      { modelo: 2, prazoInicio: 1, prazoFim: 23, taxa: 2.77 },
      { modelo: 2, prazoInicio: 24, prazoFim: 35, taxa: 2.06 },
      { modelo: 2, prazoInicio: 36, prazoFim: 47, taxa: 1.89 },
      { modelo: 2, prazoInicio: 48, prazoFim: 60, taxa: 1.85 },
      { modelo: 3, prazoInicio: 1, prazoFim: 23, taxa: 3.18 },
      { modelo: 3, prazoInicio: 24, prazoFim: 35, taxa: 2.16 },
      { modelo: 3, prazoInicio: 36, prazoFim: 47, taxa: 1.95 },
      { modelo: 3, prazoInicio: 48, prazoFim: 60, taxa: 1.90 }
    ]
  },
  GetItem (modelo, prazo) {
    return ctrl.Get().find(item => item.modelo === modelo && item.prazoInicio <= prazo && item.prazoFim >= prazo)
  },
  TipoVeiculo: [
    { text: 'Particular', value: 1 },
    { text: 'Comercial', value: 2 },
    { text: 'Oficial', value: 3 },
    { text: 'Diplomatico', value: 4 },
    { text: 'Especial', value: 5 },
    { text: 'Colecionador', value: 6 }
  ],
  TipoPlaca: [
    { text: 'Carro', value: 1 },
    { text: 'Moto', value: 2 },
    { text: 'Caminhão', value: 3 },
    { text: 'Van/Utilitário', value: 4 },
    { text: 'SUV', value: 5 }
  ],
  TipoChassi: [
    { text: 'Remarcado', value: 1 },
    { text: 'Normal', value: 2 }
  ],
  TipoRestricaoGravame: [
    { text: 'Arrendamento Mercantil/Leasing', value: 1 },
    { text: 'Reserva e Domínio/Outros', value: 2 },
    { text: 'Alienação Fiduciária', value: 3 },
    { text: 'Penhor', value: 9 }
  ],
  TabelaComissao: [
    { text: 'Modelo 0', value: 0 },
    { text: 'Modelo 1', value: 1 },
    { text: 'Modelo 2', value: 2 },
    { text: 'Modelo 3', value: 3 },
    { text: 'Modelo Taxa', value: 4 },
  ],
  GetTaxa (th) {
    var taxa = 0
    const tx = ctrl.GetItem(th.model.ModeloComissao, th.model.Parcelas)
    if (tx) {
      taxa = tx.taxa
    }
    th.$set(th.model, 'PercJurosMensal', taxa)
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * th.$param.VlrMinEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.PropostaDadosVeiculo.ZeroKM) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTAVEICULO_ZEROKM', ValorCampo: th.model.PropostaDadosVeiculo.ZeroKM }) }
    if ([null, undefined].indexOf(th.model.ModeloComissao) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_MODELOCOMISSAO', ValorCampo: th.model.ModeloComissao }) }
    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }

    if (campos.length > 0) { th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos }) }
  },
  ImportaAssinante (th, request, importEmitente) {
    if (importEmitente) {
      th.$api.Multiplo.Post('InsertCCBDigitalAssinatura', request).then(function (response) {
        th.$api.UI.PostAction(response, 'Importação realizada com sucesso!')
      })
    }
    th.$api.Multiplo.Post('ImportarCCBDigitalAssinatura', { guidID: request.dto.CodigoProposta }).then((response) => {
      if (th.$api.UI.PostAction(response, 'Importação realizada com sucesso!')) {
      }
    })
  },
  CarregaDiasAcrescimo (th, value) {
    if (value && !ctrl.AllowedDates(th, value)) {
      let date = new Date(value)
      date = th.$api.UI.Date.AddDay(date, 1).toISOString().substr(0, 10)
      th.$set(th.model, 'DtPrimeiroVencto', date)
      ctrl.CarregaDiasAcrescimo(th, date)
      return
    }
    th.model.nroDiasAcrescimoPrimPagto = th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), value)
  },
  AllowedDates (th, value) {
    if (th && value) {
      return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
    } else {
      const date = new Date(`${th} 00:00:00`)
      const dayOfWeek = date.getDay()
      const isWeekend = [0, 6].includes(dayOfWeek)
      if (!isWeekend) { return date }
    }
  },
})

export default ctrl
